import { fetchAPI } from '@/services/prismic';
import { camelize } from '@/scripts/camelize';

export const getHighlightsQuery = `
  query getHighlights($id: String!){
    allCosta_rica_highlightss(id: $id) {
      edges {
        node {
          title
          highlights {
            highlight {
              ... on Bullet {
                title
                name
                description
                logos {
                  bullet_logo
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const fetchHighlightsContent = async (id, previewData) => {
  const {
    allCosta_rica_highlightss: {
      edges: [{
        node: highlights,
      } = {}] = [],
    } = {},
  } = await fetchAPI(getHighlightsQuery, {
    previewData,
    variables: {
      id,
    },
  });

  return camelize(highlights);
};